import { useState, useEffect } from 'react';


const GetFetchWithToken = (url, token) => {
    const [data, setData] = useState([]);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const abortCont = new AbortController();
        if (`Bearer ${localStorage.getItem('token').replaceAll('"', "")}` != 'Bearer undefined') {
            fetch(url, {
                signal: abortCont.signal,
                method: "POST",
                body: JSON.stringify({
                    "inputs": [
                        {
                            "id": 148,
                            "name": "Beta-carotene",
                            "type": "herbs"
                        }
                    ],
                    "interactingEntities": []
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
                }
            })
                .then(res => {
                    if (!res.ok) { // error coming back from server
                        throw Error('could not fetch the data for that resource');
                    }
                    //console.log(res)       
                    return res.json();
                })
                .then(data => {
                    setIsPending(false);
                    setData(data);
                    setError(null);
                })
                .catch(err => {
                    if (err.name === 'AbortError') {
                        console.log('fetch aborted')
                    } else {
                        // auto catches network / connection error
                        setIsPending(false);
                        setError(err.message);
                    }
                })
        }

        // abort the fetch
        return () => abortCont.abort();
    }, [token])

    return { data, isPending, error };
}

export default GetFetchWithToken;